import DrawerSectionHeading from 'components/DrawerSectionHeading';
import SortableTopPosts from 'components/Posts/SortableTopPosts';
import Stack from 'components/Stack';
import TopPostsDownloadButton from 'components/Posts/TopPostsDownloadButton';
import useFlavorPosts from './useFlavorPosts';
import { useCurrentCountry } from 'utils/hooks';
import useTikTokWeeks from 'utils/hooks/useTikTokWeeks';
import { useTopPostsControls } from 'components/Posts/useTopPostsControls.hook';

function FlavorPostsDrawer({
    country,
    category,
    flavor,
    flavorName,
    displayQty = 5,
}) {
    const { week, year } = useTikTokWeeks();
    const countryObj = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'TopPostsSortSelect',
        tableName: 'top-posts-section-card',
    });
    const postsQuery = useFlavorPosts({
        country: country ? [country] : null,
        category: category ? [category] : null,
        flavor: flavor ? [flavor] : null,
        week: value.week,
        year: value.year,
        rank_type: value.apiRankType,
        enabled: Boolean(country && category && flavor && week && year),
    });

    return (
        <Stack $space="1rem">
            <DrawerSectionHeading>
                <span css="display: flex; align-items: center;">Top Posts</span>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={flavorName}
                        country={countryObj}
                        source="tiktok"
                        topPostsQuery={postsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                    />
                </span>
            </DrawerSectionHeading>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <SortableTopPosts
                topPostsQuery={postsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default FlavorPostsDrawer;
